import { action, observable } from 'mobx';
import map from 'lodash.map';
import Message from './Message';

class MessageStore {
  @observable showMessage = false;

  @observable messages = [];

  @observable showAlert = false;

  @observable alerts = [];

  @action
  populateMessages = () => {
    this.messages = map(this.messages, message => new Message(message));
    if (this.messages.length > 0) {
      this.showMessage = true;
    }
  };

  @action
  populateAlerts = () => {
    this.alerts = map(this.messages, message => new Message(message));
    if (this.alerts.length > 0) {
      this.showAlert = true;
    }
  };

  @action
  disableMessage = () => {
    this.showMessage = false;
  };

  @action
  setMessages = (message, messageType) => {
    this.messages = [];
    if (message !== '' && messageType !== '') {
      const messages = [];
      const messageObj = new Message();
      messageObj.message = message;
      messageObj.messageType = messageType;
      messages.push(messageObj);
      this.messages = messages;
    }
  };
}

export default new MessageStore();